import { fieldLevelValidators, validators } from "utils/validators";
import { fetchFieldValue, setFieldValue } from "./mle.utils";

export const generalValidationFunction = (values, fields, idxName) => {
    const errors = {};
    try {
        
        Object.keys(fields).map(item => {
            let itemData = fields[item];
            let name = typeof itemData.name !== 'string' ? itemData.name(idxName) : itemData.name;
            
            let fieldData = fetchFieldValue(values, name);
            
            if (itemData?.fieldValidations) {
                let fieldValidations = itemData.fieldValidations;
                if (fieldValidations.required) {
                    setFieldValue(errors, name, fieldLevelValidators.required(fieldData));
                }
                if (fieldValidations.emailValid && fieldData) {
                    setFieldValue(errors, name, fieldLevelValidators.email(fieldData));
                }
                if (fieldValidations.mobileValid && fieldData) {
                    setFieldValue(errors, name, fieldLevelValidators.mobileNumber(fieldData));
                }
                if (fieldValidations.panValid && fieldData) {
                    setFieldValue(errors, name, fieldLevelValidators.pan(fieldData));
                }
                if (fieldValidations.gstValid && fieldData) {
                    setFieldValue(errors, name, fieldLevelValidators.gst(fieldData));
                }
                if (fieldValidations.aadharValid && fieldData) {
                    setFieldValue(errors, name, fieldLevelValidators.aadhar(fieldData));
                }
                if (fieldValidations.numericValid && fieldData) {
                    setFieldValue(errors, name, fieldLevelValidators.numeric(fieldData));
                }
                if (fieldValidations.alphaValid && fieldData) {
                    setFieldValue(errors, name, fieldLevelValidators.alphaWithSpace(fieldData));
                }
                if (fieldValidations.urlValid && fieldData) {
                    setFieldValue(errors, name, validators.URL(fieldData));
                }
                if (fieldValidations.pinValid && fieldData) {
                    setFieldValue(errors, name, fieldLevelValidators.pin(fieldData));
                }
                if (fieldValidations.haveNumberValid && fieldData) {
                    
                    setFieldValue(errors, name, fieldLevelValidators.containsNumber(fieldData));
                }
                if(fieldValidations.maxLength && fieldData){
                    setFieldValue(errors, name, fieldLevelValidators.maxLength(fieldData, fieldValidations.maxLength))
                }
            }
        })
        
    } catch(e) {
        console.log("errors general validator", e);
    }
    return errors;
}